var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setAvtive", staticStyle: { height: "100%" } },
    [_c("listNull", { attrs: { text: "此功能暂未开启~" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }